module.exports = __webpack_public_path__ + "img/Badge.3ae73163.svg";